<template>
  <PreviewElementWrapper 
    :initial-selected="isSelected"
    :element-type="element.type"
    :element="element"
    :selectedPreviewId="selectedPreviewId"
    :disabled="disabled"
    @select-change="handleSelectChange"
    @update-element-data="$emit('update-element-data', $event)"
    @auto-mapping="(id)=>$emit('auto-mapping', id)"
    @element-edit-state-changed="$emit('element-edit-state-changed', $event)"
  >
    <div class="dummy-field-input" @mouseenter="showTooltip = true" @mouseleave="showTooltip = false">
      <span class="placeholder-text">Enter email address ...</span>
      <FieldTooltip :visible="showTooltip" />
    </div>
  </PreviewElementWrapper>
</template>

<script>
import PreviewElementWrapper from './PreviewElementWrapper.vue';
import FieldTooltip from './FieldTooltip.vue';

export default {
  name: 'EmailPreview',
  components: { PreviewElementWrapper, FieldTooltip },
  props: {
    element: { type: Object, default: () => ({}) },
    selectedPreviewId: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      showTooltip: false,
      isSelected: false
    };
  },
  emits: [
    'update-element-data',
    'auto-mapping',
    'element-edit-state-changed'
  ],
  methods: {
    handleSelectChange(isSelected) {
      this.isSelected = isSelected;
    }
  }
};
</script>

<style scoped>
.dummy-field-input {
  position: relative;
  background: #fff;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  height: 40px;
  width: 100%;
  display: flex;
  padding: 8px 20px;
}

.placeholder-text {
  color: #E0E0E0;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.15px;
}
</style>
